/**
 * @file modals-queue-slice.ts
 * @description Redux slice для управления очередью модальных окон в Task Manager приложении. Обеспечивает централизованное управление состоянием открытых модальных окон с возможностью добавления, удаления и установки списка активных модалей для предотвращения конфликтов отображения.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['@reduxjs/toolkit', '@src/store']
 * @related-files ['src/store/index.ts', 'src/components/ui/modal', 'src/hooks/useModal.ts']
 */

import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@src/store';

export interface IModalsQueueSlice {
    items: string[];
}

const initialState: IModalsQueueSlice = {
    items: []
};

export const modalsQueueSlice = createSlice({
    name: 'modals-queue',
    initialState,
    reducers: {
        setItems: (state, action: PayloadAction<string[]>) => {
            state.items = action.payload;
        },
        removeItem: (state, action: PayloadAction<string>) => {
            state.items = state.items.filter((item) => item !== action.payload);
        },
        addItem: (state, action: PayloadAction<string>) => {
            state.items = [...state.items, action.payload];
        }
    }
});
export const { addItem, removeItem, setItems } = modalsQueueSlice.actions;
export const getItems = (state: RootState): string[] => state.modalsQueueStore.items;
export default modalsQueueSlice.reducer;
